import React from 'react';
const comparisonRows = [{
  situation: 'Tus lavados',
  without: 'Rayones circulares en cada trabajo',
  with: 'Protocolo de 3 baldes sin un solo rayón'
}, {
  situation: 'Tu técnica',
  without: 'Videos de YouTube contradictorios',
  with: 'Sistema paso a paso probado en taller'
}, {
  situation: 'Tus precios',
  without: 'Cobrás barato por miedo al rechazo',
  with: 'Presupuestos de $150k a $400k con confianza'
}, {
  situation: 'Tus clientes',
  without: 'Sin método para conseguirlos',
  with: 'Sistema de captación de alto ticket activo'
}, {
  situation: 'Tu agenda',
  without: 'Vacía o llena de trabajos baratos',
  with: 'Llena de servicios premium en 30 días'
}, {
  situation: 'Tus insumos',
  without: 'Comprás sin saber qué usar ni cuánto',
  with: 'Tabla de diluciones y costos exactos'
}, {
  situation: 'Tus cerámicos',
  without: 'High spots y errores de aplicación',
  with: 'Protocolo de sellado sin fallas garantizado'
}, {
  situation: 'Tu negocio',
  without: 'Lavadero de garage sin identidad',
  with: 'Taller de estética automotriz de élite'
}];
const blocks = [{
  emoji: '💰',
  title: 'Bloque 1 — El Sistema del Alto Ticket',
  desc: 'Cómo posicionarte como el detailer de referencia en tu ciudad y cobrar entre $150.000 y $400.000 por servicio sin miedo ni negociación.',
  span: false
}, {
  emoji: '🏆',
  title: 'Bloque 2 — Sellado Cerámico Avanzado',
  desc: 'Domina el 9H, el Grafeno y el Vidrio Líquido. El servicio más rentable del detailing con protocolo de aplicación paso a paso sin errores.',
  span: false
}, {
  emoji: '🎯',
  title: 'Bloque 3 — Captación de Clientes de Lujo',
  desc: 'Cómo llegar a los dueños de BMW, Mercedes y Porsche de tu ciudad. Alianzas con concesionarias, countries y agencias de autos premium.',
  span: false
}, {
  emoji: '🧪',
  title: 'Bloque 4 — La Química que los Proveedores Ocultan',
  desc: 'pH, abrasividad, Iron Removers y compuestos. Todo lo que necesitás saber para no ser engañado y elegir los productos correctos.',
  span: false
}, {
  emoji: '📊',
  title: 'Assets incluidos en El Método Cerámico™:',
  desc: 'Tabla de dureza de lacas por marca · Script de WhatsApp para cerrar presupuestos · Contrato de servicio profesional · Calculadora de tarifas · Guía de curado infrarrojo · Plan de alianzas estratégicas · Sistema de garantía pro',
  span: true
}];
export function ProBusiness() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#131313',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-229">
      <div className="mx-auto max-w-4xl" data-id="element-230">
        {/* Header */}
        <div className="mb-8 text-center" data-id="element-231">
          <h2 className="font-black text-white m-0 mb-3 text-[26px]" data-id="element-232">
            🏆 ¿QUÉ AGREGA{' '}
            <span className="text-yellow-400" data-id="element-233">EL MÉTODO CERÁMICO™</span>?
          </h2>
          <p className="mx-auto max-w-2xl text-base text-gray-400 m-0" data-id="element-234">
            El sistema de sellado cerámico, clientes de lujo y alto ticket que
            convierte tu garage en un taller de estética automotriz de élite.
          </p>
        </div>

        {/* Swipe hint mobile */}
        <p className="text-xs text-gray-500 text-center mb-2 sm:hidden flex items-center justify-center gap-1" data-id="element-235">
          <span data-id="element-236">👆</span> Deslizá para ver la tabla completa
        </p>

        {/* Comparison Table */}
        <div className="mb-10 overflow-x-auto border border-yellow-400/20 rounded-xl shadow-sm touch-pan-x" style={{
        backgroundColor: 'rgba(255,255,255,0.02)',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-237">
          <div className="min-w-[600px]" data-id="element-238">
            {/* Table Header */}
            <div className="grid grid-cols-3" style={{
            backgroundColor: 'rgba(255,255,255,0.03)'
          }} data-id="element-239">
              <div className="p-3 text-sm font-bold text-gray-300" data-id="element-240">
                Situación
              </div>
              <div className="p-3 text-center text-sm font-bold text-gray-500 border-l border-yellow-400/20" data-id="element-241">
                Sin El Método Cerámico™
              </div>
              <div className="p-3 text-center text-sm font-bold text-yellow-400 border-l border-yellow-400/20" data-id="element-242">
                Con El Método Cerámico™
              </div>
            </div>

            {/* Table Rows */}
            {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-white/5' : ''}`} data-id="element-243">
                <div className="p-3 text-xs sm:text-sm text-gray-300" data-id="element-244">
                  {row.situation}
                </div>
                <div className="p-3 text-xs sm:text-sm text-gray-500 border-l border-white/5 bg-white/[0.02]" data-id="element-245">
                  {row.without}
                </div>
                <div className="p-3 text-xs sm:text-sm text-gray-200 border-l border-white/5 bg-yellow-400/5" data-id="element-246">
                  {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* Includes Section */}
        <h3 className="text-xl font-black text-center text-white m-0 mb-6" data-id="element-247">
          ✅ EL MÉTODO CERÁMICO™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-248">
          {blocks.map(block => <div key={block.title} className={`border border-yellow-400/20 rounded-lg p-4 shadow-sm ${block.span ? 'md:col-span-2' : ''}`} style={{
          backgroundColor: 'rgba(234, 179, 8, 0.03)'
        }} data-id="element-249">
              <h4 className="text-base font-bold text-yellow-400 m-0 mb-1" data-id="element-250">
                {block.emoji} {block.title}
              </h4>
              <p className="text-xs text-gray-400 m-0" data-id="element-251">{block.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}